@for (socialNetwork of socialNetworks; track $index; let i = $index) {
  <a
    [href]="socialNetwork.link"
    target="_blank"
    class="socials__social"
    (mouseenter)="onMouseEnter(i)"
    (mouseleave)="onMouseLeave(i)"
    (mousemove)="onMouseMove(i)"
  >
    <img
      loading="lazy"
      src="assets/icons/{{ socialNetwork.name }}.svg"
      alt="{{ socialNetwork.name }}"
      class="socials__social-icon"
    />

    <div class="socials__social-link"></div>
  </a>
}
